import React from 'react';
import { connect } from 'react-redux';

import { selectPlan } from '../../redux/auth/user/selectors';

import UserPlanTag from './UserPlanTag';

const UserPlanTagConnected = (props) => <UserPlanTag {...props} />;

const mapStateToProps = (state) => ({
  planName: selectPlan(state),
});

export default connect(mapStateToProps, null)(UserPlanTagConnected);
